import {
  IGridVodItem,
  isBanner,
  isIFrameBlock,
  isLayout3,
  isLayout4,
  isLayout6,
  isLayout7,
  isLiveBroadcast,
  isMainStandardItem,
  isMainTextOverItem,
  isMatrix1x4,
  isMatrix2x4,
  isSpecialRef,
  isVod,
  IVodItem,
} from '../../types'
import {
  IFrame,
  LiveBroadcast,
  MainStandard,
  MainTextOver,
} from '../../components/Main'
import { Layout4, Layout6 } from '../../components/Layout'
import LayoutWithBanner from '../../components/Layout/LayoutWithBanner'
import { Banner } from '../../components/Ads/Banner'
import { Matrix1x4, Matrix2x4 } from '../../components/Matrix'
import { SpecialRef } from '../../components/GridBlocks'
import { Vod } from '../../components/DynamicComponents'

export const commonItemToComponent = ({
  item,
  i,
}: {
  item: IGridVodItem | IVodItem
  i: number
}) => {
  const { grid_id } = item

  if (isMainStandardItem(item)) {
    return <MainStandard mainStandard={item} key={`${i} ${grid_id}`} />
  }
  if (isLayout6(item)) {
    return <Layout6 layout={item} key={`${i} ${grid_id}`} />
  }
  if (isLayout3(item)) {
    return (
      <LayoutWithBanner
        postsInBlock={3}
        index={i}
        layout={item}
        key={`${i} ${grid_id}`}
      />
    )
  }
  if (isLayout7(item)) {
    return (
      <LayoutWithBanner
        postsInBlock={7}
        index={i}
        layout={item}
        key={`${i} ${grid_id}`}
      />
    )
  }
  if (isBanner(item)) {
    return <Banner banner={item} key={`${i} ${grid_id}`} collapse={false} />
  }
  if (isMatrix2x4(item)) {
    return <Matrix2x4 matrix={item} key={`${i} ${grid_id}`} />
  }
  if (isMatrix1x4(item)) {
    return <Matrix1x4 matrix={item} key={`${i} ${grid_id}`} />
  }
  if (isVod(item)) {
    return <Vod vod={item} key={`${i} ${grid_id}`} />
  }
  if (isSpecialRef(item)) {
    return <SpecialRef specialRef={item} key={`${i} ${grid_id}`} />
  }
  if (isLayout4(item)) {
    return <Layout4 layout={item} key={`${i} ${grid_id}`} />
  }
  if (isMainTextOverItem(item)) {
    return <MainTextOver mainTextOver={item} key={`${i} ${grid_id}`} />
  }
  if (isLiveBroadcast(item)) {
    return (
      <LiveBroadcast
        liveBroadcast={item}
        key={`${i} ${grid_id}`}
        isFirst={false}
      />
    )
  }
  if (isIFrameBlock(item)) {
    return <IFrame iFrame={item} key={`${i} ${grid_id}`} />
  }

  return null
}
